import api from './api';

export const createPunchPoint = (data) => api.post('/punch-points/', data);

export const getPunchPoints = (params = {}) =>
  api.get('/punch-points/', { params });

export const getPunchPoint = (id) => api.get(`/punch-points/${id}`);

export const completePunchPoint = (id, completion_summary) =>
  api.put(`/punch-points/${id}/complete`, { completion_summary });

export const verifyPunchPoint = (id, verification_notes) =>
  api.put(`/punch-points/${id}/verify`, { verification_notes });

export const rejectPunchPoint = (id, rejection_reason) =>
  api.put(`/punch-points/${id}/reject`, { rejection_reason });

export const getOverduePunchPoints = () => api.get('/punch-points/overdue');

export const deletePunchPoint = (id) => api.delete(`/punch-points/${id}`);

export const archivePunchPoint = (id) => api.put(`/punch-points/${id}/archive`);

export const unarchivePunchPoint = (id) => api.put(`/punch-points/${id}/unarchive`);

export const getIssueTypes = () => api.get('/punch-points/issue-types/all');

export const createIssueType = (name) => api.post('/punch-points/issue-types', { name });

export const deleteIssueType = (id) => api.delete(`/punch-points/issue-types/${id}`);

export const validateTaskIssueImport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  // No explicit Content-Type - see api.js's 2026-09-13 comment on why
  // setting it here breaks the multipart boundary axios/the browser add
  // automatically for a FormData body.
  return api.post('/punch-points/import/validate', formData);
};

export const commitTaskIssueImport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/punch-points/import/commit', formData);
};

export const getSampleXlsx = () => api.get('/punch-points/import/sample.xlsx', { responseType: 'blob' });
